import PropTypes from "prop-types";
import {LightBulbIcon} from "@heroicons/react/24/outline";
import {useState, useEffect} from "react";
import {XMarkIcon} from "@heroicons/react/20/solid";


export default function VerticalCard(props) {
    const [shouldShowDescription, setShouldShowDescription] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };

        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    const cardStyle = () => {
        if (props.cardColor) {
            return {
                color: "#ffffff",
                backgroundColor: props.cardColor === "blue" ? "#0071e3" : "#000000",
            };
        } else {
            return {
                backgroundColor: "#ffffff",
            };
        }
    };

    const effectiveMargin = isMobile ? "0px" : props.imageMargin;
    const effectiveSuperSize = isMobile ? false : props.superSizeTitle;

    return (
        <div className={`relative w-full ${shouldShowDescription ? "expanded-mobile-card" : ""}`}>
            {props.imageSource ? (
                <div>
                    {props.imagePosition === "top" && topView()}
                    {props.imagePosition === "bottom" && bottomView()}
                </div>
            ) : (
                <div className="rounded-2xl" style={cardStyle()}>
                    <div className="flex items-center p-12 vertical-card-inner">
                        <div
                            className="text-8 vertical-card-title"
                            style={{
                                fontWeight: "600",
                                fontSize: effectiveSuperSize ? "64px" : "42px",
                                lineHeight: "1.2",
                            }}
                        >
                            {props.title}
                        </div>
                    </div>
                </div>
            )}

            {Boolean(props.description) && (
                <div
                    className="absolute z-10 bottom-8 right-6 lightbulb-btn bg-gray-500 rounded-full p-2 cursor-pointer text-white hover:text-black hover:bg-yellow-200"
                    onClick={() => setShouldShowDescription(!shouldShowDescription)}
                >
                    {shouldShowDescription ? <XMarkIcon className="w-8"/> :
                        <LightBulbIcon className="w-8 hover:color-black"/>}
                </div>
            )}

            {shouldShowDescription && (
                <div
                    className="absolute w-full h-full top-0 rounded-2xl bg-black p-2 cursor-pointer"
                    onClick={() => setShouldShowDescription(false)}
                >
                    <div className="flex items-center justify-center h-full">
                        <div className="text-white w-3/4 space-y-8">
                            <div className="font-semibold text-2xl">{props.title}</div>
                            <div>{props.description}</div>
                        </div>
                    </div>
                </div>
            )}

            <style>
                {`
              @media (max-width: 767px) {
                .vertical-card-inner {
                  // padding: 2.5rem !important;
                }
            
                .vertical-card-title {
                  font-size: 28px !important;
                  line-height: 1.3 !important;
                }
            
                .lightbulb-btn {
                  bottom: 0.75rem !important;
                  right: 0.75rem !important;
                }
                
                .expanded-mobile-card {
                  min-height: 550px !important;
                }
              }

            `}
            </style>

        </div>
    );

    function topView() {
        return (
            <div className="bg-white rounded-2xl">
                <div>
                    <img
                        className="object-contain rounded-t-2xl"
                        src={props.imageSource}
                        alt={props.title}
                        style={{
                            width: "100%",
                            maxHeight: "350px",
                            height: props.imageHeight || "100%",
                            marginTop: effectiveMargin,
                        }}
                    />
                </div>
                <div className="flex items-center p-12 pt-4 vertical-card-inner">
                    <div
                        className="text-8 vertical-card-title"
                        style={{
                            fontWeight: "600",
                            fontSize: effectiveSuperSize ? "64px" : "42px",
                            lineHeight: "1.2",
                        }}
                    >
                        {props.title}
                    </div>
                </div>
            </div>
        );
    }

    function bottomView() {
        return (
            <div className="bg-white rounded-2xl">
                <div className="flex items-center p-12 pb-8 vertical-card-inner">
                    <div
                        className="text-8 vertical-card-title"
                        style={{
                            fontWeight: "600",
                            fontSize: effectiveSuperSize ? "64px" : "42px",
                            lineHeight: "1.2",
                        }}
                    >
                        {props.title}
                    </div>
                </div>
                <div>
                    <img
                        className="object-contain rounded-b-2xl"
                        src={props.imageSource}
                        alt={props.title}
                        style={{
                            width: "100%",
                            maxHeight: "350px",
                            height: props.imageHeight || "100%",
                            marginBottom: effectiveMargin,
                        }}
                    />
                </div>
            </div>
        );
    }
}

VerticalCard.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    cardColor: PropTypes.string,
    imageSource: PropTypes.string,
    imagePosition: PropTypes.string,
    imageHeight: PropTypes.string,
    imageMargin: PropTypes.string,
    superSizeTitle: PropTypes.bool,
};
